export default __webpack_public_path__ + "static/media/electricity-company.2d4be885.svg";